module.exports = __webpack_public_path__ + "static/img/Mary-Fowler.2dd3d9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mary-Fowler.jpg
// module id = RoHR
// module chunks = 0